import { FiArrowLeft } from "react-icons/fi";
import {
  mintSpaceHairlineClass,
  mintSpaceIconBtnClass,
  mintSpaceBodyClass,
} from "../styles/mintSpaceChrome";

/** Compact sidebar nav row — soft fill when active (classic Mintly glass panels). */
export function mintSpaceSidebarNavButtonClass(isActive, isDark) {
  if (isActive) {
    return isDark
      ? "group relative w-full flex items-center gap-2 rounded-radius-xs px-2 py-1.5 text-left text-caption-1-semibold text-slate-50 bg-white/10 ring-1 ring-inset ring-white/10 transition-colors"
      : "group relative w-full flex items-center gap-2 rounded-radius-xs px-2 py-1.5 text-left text-caption-1-semibold text-slate-900 bg-slate-100 ring-1 ring-inset ring-slate-200 transition-colors";
  }
  return "group relative w-full flex items-center gap-2 rounded-radius-xs px-2 py-1.5 text-left text-caption-1 font-medium text-label-secondary hover:bg-fill-quaternary hover:text-label-primary transition-colors";
}

export function mintSpaceMobileNavButtonClass(isActive, isDark) {
  if (isActive) {
    return isDark
      ? "flex-shrink-0 flex items-center gap-1.5 px-2.5 py-2 text-caption-1-semibold text-accent-text border-b-2 border-accent-default bg-white/5"
      : "flex-shrink-0 flex items-center gap-1.5 px-2.5 py-2 text-caption-1-semibold text-status-success border-b-2 border-status-success bg-status-success-bg";
  }
  return "flex-shrink-0 flex items-center gap-1.5 px-2.5 py-2 text-caption-1 font-medium text-label-secondary hover:text-label-primary hover:bg-fill-quaternary";
}

/**
 * Shared sidebar top for Mint Space hub and campaign-details shell.
 */
export default function MintSpaceSidebarBannerHeader({
  isDark,
  mutedText: _mutedText,
  title,
  imageUrl,
  imageAlt,
  placeholderLabel,
  onBack,
  backAriaLabel = "Back",
  children,
}) {
  const initial = (title || "M").charAt(0).toUpperCase();

  return (
    <div className={`flex-shrink-0 border-b ${mintSpaceHairlineClass(isDark)}`}>
      <div className="flex items-center gap-1.5 px-2.5 pt-2 pb-0.5">
        {onBack && (
          <button
            type="button"
            onClick={onBack}
            className={`flex h-7 w-7 items-center justify-center rounded-md transition ${mintSpaceIconBtnClass(isDark)}`}
            aria-label={backAriaLabel}
          >
            <FiArrowLeft className="h-3.5 w-3.5" />
          </button>
        )}
      </div>
      <div className="flex items-center gap-2.5 px-2.5 pb-2.5 pt-1">
        <div
          className={`flex h-8 w-8 shrink-0 items-center justify-center overflow-hidden rounded-radius-xs text-footnote-semibold ${
            isDark
              ? "bg-accent-default text-accent-on ring-1 ring-white/10"
              : "bg-accent-default text-accent-on ring-1 ring-slate-200"
          }`}
        >
          {imageUrl ? (
            <img src={imageUrl} alt={imageAlt || ""} className="h-full w-full object-cover" />
          ) : (
            placeholderLabel || initial
          )}
        </div>
        <div className="min-w-0 flex-1">
          <h3
            className={`truncate font-ds text-footnote-semibold tracking-tight ${mintSpaceBodyClass(isDark)}`}
          >
            {title || "Mint Space"}
          </h3>
          {children}
        </div>
      </div>
    </div>
  );
}
